import { Invoice } from '../types/types';

export const isInvoicePaid = (
  invoice: Pick<Invoice, 'status'> | undefined
): boolean => invoice?.status?.toLowerCase() === 'paid';
